module.exports = __webpack_public_path__ + "static/12-7691ca9e6f47a19ae3621f39245e36f6.jpg";